export const API_ROUTES = {
  COMPANY_LIST: '/companies',
  RECRUITER_SIGNUP: '/recruiter',
  SIGNIN: '/login',
  MANAGER_SIGNUP: '/student_societies',
  USER_INFO: '/user',
  USER_CONFIRMATION: '/users',
  STUDENT_SOCIETIES: '/student_societies',
  SIMILAR_STUDENT_SOCIETIES: '/similar',
  UNIVERSITIES: '/universities',
  TOPICS: '/tags?type=Topic',
  CAMPAIGNS: '/touchpoints',
  CAMPAIGN_QUESTIONS: '/questions/create_multiple',
  COMPANY_PROFILE: '/company',
  BENEFITS: '/benefits',
  COMPANY_BENEFIITS: '/company/companies_benefits',
  COUNTRIES: '/countries',
  COMPANY_NATIONALITIES: '/company/nationalities',
  COMPANY_INSIGHTS: '/company/insights',
  PASSWORD_RESET: '/password',
  APPLICATIONS: '/touchpoint_applications',
  UPDATE_STATUS: '/update_status',
  ROOMS: '/rooms',
  ROOM_MESSAGES: '/messages',
  EMAIL_VERIFICATION: '/user/email',
  CANDIDATE_SIGNUP: '/student_society_registrations',
  STUDENT_SOCIETY_REGISTRATION: '/student_society_registrations',
  HIGHLIGHTS: '/highlights',
  SOCIETY_HIGHLIGHTS: '/student_societies_highlights',
  STUDENT_SOCIETY: '/student_society',
  OFFERINGS: '/tags?type=Offering',
  TEAM_MEMBERS: '/student_society/team_members',
  FLAGSHIP_EVENTS: '/student_society/flagship_events',
  SOCIETY_STATS: '/student_society/stats',
  COMPANY_STATS: '/company/stats',
};
